import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IMaterial, IMaterialXLeistung, MaterialChangeRequest } from '@/shared/model/material.model';
const baseApiUrl = 'api/material';

export default class MaterialService {
  public change(request: MaterialChangeRequest[]): Promise<any> {
    return axios.post(`${baseApiUrl}Change`, request);
  }

  public retrieve(req?: any): Promise<any> {
    return axios.get(`${baseApiUrl}?${buildPaginationQueryOpts(req)}`);
  }

  public retrieveByXLeistung(isGrundleistung, leistungID): Promise<any> {
    const grundId = isGrundleistung ? leistungID : null;
    const zleistId = isGrundleistung ? -1 : leistungID;
    return axios.get(`${baseApiUrl}XLeistung/${isGrundleistung}/${grundId}/${zleistId}`);
  }

  public retrieveTermin(termin): Promise<any> {
    return axios.post(`${baseApiUrl}Termin`, termin);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<IMaterial> {
    return new Promise<IMaterial>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public addMaterialToLeistung(list: IMaterialXLeistung[]): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}XLeistung`, list)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateMaterialToLeistung(list: IMaterialXLeistung[], isGrundleistung, leistungID): Promise<boolean> {
    const grundId = isGrundleistung ? leistungID : null;
    const zleistId = isGrundleistung ? -1 : leistungID;
    return new Promise<boolean>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}XLeistung/${isGrundleistung}/${grundId}/${zleistId}`, list)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IMaterial): Promise<IMaterial> {
    return new Promise<IMaterial>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IMaterial): Promise<IMaterial> {
    return new Promise<IMaterial>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
